"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SSO_ENABLED = exports.CREATED_BY = exports.CREATED_AT = exports.PORTAL_ID = exports.USER_ID = exports.USER_EXEMPTION = exports.EXEMPT_USER_IDS = exports.NOT_REQUIRED = exports.REQUIRED = exports.SERVICE = exports.ENTITY = exports.CERTIFICATE = exports.IDENTITY_PROVIDER = exports.USER_EXEMPTIONS = exports.CONFIRMED_SAML_IDP = exports.PENDING_SAML_IDP = exports.REQUIREMENT = exports.SAML_SETTINGS = void 0;
var SAML_SETTINGS = 'samlSettings';
exports.SAML_SETTINGS = SAML_SETTINGS;
var REQUIREMENT = 'requirement';
exports.REQUIREMENT = REQUIREMENT;
var PENDING_SAML_IDP = 'pendingSamlIdp';
exports.PENDING_SAML_IDP = PENDING_SAML_IDP;
var CONFIRMED_SAML_IDP = 'confirmedSamlIdp';
exports.CONFIRMED_SAML_IDP = CONFIRMED_SAML_IDP;
var USER_EXEMPTIONS = 'userExemptions';
exports.USER_EXEMPTIONS = USER_EXEMPTIONS;
var IDENTITY_PROVIDER = 'identityProvider';
exports.IDENTITY_PROVIDER = IDENTITY_PROVIDER;
var CERTIFICATE = 'certificate';
exports.CERTIFICATE = CERTIFICATE;
var ENTITY = 'entity';
exports.ENTITY = ENTITY;
var SERVICE = 'service';
exports.SERVICE = SERVICE;
var REQUIRED = 'REQUIRED';
exports.REQUIRED = REQUIRED;
var NOT_REQUIRED = 'NOT_REQUIRED';
exports.NOT_REQUIRED = NOT_REQUIRED;
var EXEMPT_USER_IDS = 'exemptUserIds';
exports.EXEMPT_USER_IDS = EXEMPT_USER_IDS;
var USER_EXEMPTION = 'userExemption';
exports.USER_EXEMPTION = USER_EXEMPTION;
var USER_ID = 'userId';
exports.USER_ID = USER_ID;
var PORTAL_ID = 'portalId';
exports.PORTAL_ID = PORTAL_ID;
var CREATED_AT = 'createdAt';
exports.CREATED_AT = CREATED_AT;
var CREATED_BY = 'createdBy';
exports.CREATED_BY = CREATED_BY;
var GET_SSO_ENABLED = 'ssoEnabled';
exports.GET_SSO_ENABLED = GET_SSO_ENABLED;